import { useRef } from 'react';
import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { MembershipPaymentTermSelector } from '#src/app/shared/components/membershipPaymentTermSelector';

import type { Props } from '../../shared/types';
import { AmountSelector } from '../AmountSelector';

import { useMembershipAwarenessPlacementConfig } from './hooks/useMembershipAwarenessPlacementConfig';
import { useTracking } from './hooks/useTracking';

export const MembershipAwareness: React.FC<Props> = ({ sourceLocation, slug, signed }) => {
	const element = useRef<HTMLDivElement>(null);
	const {
		data: {
			headlinePart1,
			headlinePart2,
			body,
			ctaQuestion,
			heroImage,
			heroImageAltText,
			paymentTerm,
			showOneTimePaymentTerm,
			showYearlyPaymentTerm,
		},
		actions: { onChange },
	} = useMembershipAwarenessPlacementConfig();

	useTracking({ sourceLocation, element });

	return (
		<div
			ref={element}
			id="membership-awareness"
			className="bg-background-raised mb-6 flex w-fit flex-col gap-4 rounded-lg"
		>
			<div className="flex justify-center md:hidden">
				{/* eslint-disable-next-line jsx-a11y/alt-text */}
				<img alt={heroImageAltText} src={heroImage} />
			</div>
			<div className="p-6">
				<div className="mb-6">
					<Text as="h2" variant="heading" size="small">
						<span className="font-normal">{headlinePart1} — &nbsp;</span>
						<span className="inline-block">
							<span className="relative z-[1]">{headlinePart2}</span>
							<span className="bg-fill-accent-primary-weak relative top-[-10px] block h-4 max-w-full rounded-lg" />
						</span>
					</Text>
				</div>

				<div className="flex flex-wrap gap-6">
					<div className="flex min-w-[250px] flex-1 flex-col gap-4">
						<Text>{body}</Text>
						<Text fontWeight="bold">{ctaQuestion}</Text>
					</div>
					<div className="min-w-[250px] flex-1">
						<MembershipPaymentTermSelector
							paymentTerm={paymentTerm}
							onChange={onChange}
							name="payment-terms-awareness"
							showYearlyPaymentTerm={showYearlyPaymentTerm}
							showOneTimePaymentTerm={showOneTimePaymentTerm}
						/>
						<AmountSelector sourceLocation={sourceLocation} slug={slug} signed={signed} />
					</div>
				</div>
			</div>
		</div>
	);
};
